<template>
  <v-container>
    <v-container style="display: flex; justify-content: space-between;">
      <h2>Recebimento de Nota Fiscal</h2>
    </v-container>
    <v-container class="d-flex flex-column flex-md-row justify-space-between pt-2" style="background-color: transparent; gap: 24px;" :class="themeClass">
      <div class="d-flex" style="width: 100%; gap: 4px;">
        <v-text-field
          v-model="searchText"
          label="Chave de Acesso"
          dense
          outlined
        />
        <v-btn @click="getNF" height="40" style="box-shadow: none; margin: 0px 1px; background-color: blue; color: white !important;">
          <v-icon >mdi-magnify</v-icon>
        </v-btn>
        <v-btn @click="setIsBarcodeModalOpen" height="40" style="box-shadow: none; margin: 0px 0px; background-color: blue; color: white !important;">
          <v-icon >mdi-barcode</v-icon>
        </v-btn>
        <v-btn @click="setIsImportXmlOpen" height="40" style="box-shadow: none; margin: 0px 0px; background-color: blue; color: white !important;">
          <v-icon >
            mdi-xml
          </v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-end gx-4">
        <v-menu>
          <template v-slot:activator="{ on }">
              <v-btn
                style="background-color: blue; color: white !important;"
                v-on="on" 
                height="40"
                :disabled="selectedItem.length == 0 || !selectedItem.every(item => item.osItem) || isSaving"
              >
                Ações
              </v-btn>
          </template>

          <v-list>
              <v-list-item
                  v-for="(item, index) in actionsMassa"
                  :key="index"
                  :value="index"
                  @click="item.handle"
                  class="cursor-pointer"
              >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          :disabled="notaFiscalItems.length == 0 || isSaving"
          height="40"
          style="
            box-shadow: none;
            background-color: blue;
            color: white !important;
            margin: 0px 2px;
          "
          @click="Update"
        >
          Salvar
          <v-icon style="padding-left: 4px; color: white !important;">mdi-content-save</v-icon>
        </v-btn>
      </div>
    </v-container>
    <v-container v-if="notaFiscal" class="d-flex flex-column" style="gap: 16px;">

      <v-card style="padding: 16px; gap: 16px;" class="d-sm-flex align-between">
        <p style="display: flex; margin-bottom: 0; align-items: center;"><strong>Conta:</strong> {{ notaFiscalConta.name ?? '' }}</p>
        <p style="display: flex; margin-bottom: 0; align-items: center;"><strong>NF:</strong> {{ notaFiscal?.numero }}</p>
        <v-autocomplete
          v-if="notaFiscalItems.length > 0 && notaFiscalItems.every(item => item.status === 'Pendente')"
          v-model="pedidoCompra"
          :items="pedidoCompraOptions"
          label="Pedido de Compra"
          item-text="text"
          item-value="id"
          dense
        />
        <p v-else-if="notaFiscalItems.length > 0" style="display: flex; margin-bottom: 0; align-items: center;"><strong>Cod. Pedido:</strong> {{ notaFiscalItems[0].codPurchaseOrder }}</p>
      </v-card> 
      
      <v-form ref="form" v-model="isFormValid">
        <v-card
          v-for="(item, i) in notaFiscalItems"
          :key="i"
          style="padding: 16px; gap: 16px; margin-bottom: 16px;"
          class="d-flex flex-column flex-sm-row flex-wrap justify-sm-space-between align-sm-center"
          :class="{
            'red darken-2 white--text justify-start': item.status === 'Recusado',
            'green darken-2 white--text justify-start': item.status === 'Recebido',
            'yellow darken-3 white--text justify-start': item.status === 'Recebido_Parcialmente'
          }"
        >
          <v-checkbox
            v-if="item.status === 'Pendente'"
            :input-value="isItemSelected(item)"
            @change="onItemCheck(item)"
            class="ma-0 pa-0"
          />
          <v-btn
            v-if="item.status === 'Pendente'"
            @mouseover="hoveredItem = item._id"
            @mouseleave="hoveredItem = ''"
            @click="handleOpenDeleteItemModal(item)"
            color="red"
            :disabled="!item.osItem"
          >
            <v-icon color="white">{{ hoveredItem === item._id ? 'mdi-delete-empty' : 'mdi-delete'}}</v-icon>
          </v-btn>
          <p class="mb-0 pt-2"><strong>Item:</strong> {{ item.seqitem }}</p>
          <p class="mb-0 pt-2"><strong>Descrição:</strong> {{ item.descriptionItem }}</p>
          <p class="mb-0 pt-2"><strong>Quantidade (NF):</strong> {{ item.qty }}</p>
          <p class="mb-0 pt-2"><strong>Quantidade Recebida:</strong> {{ item.qtyReceived }}</p>
          <p class="mb-0 pt-2"><strong>Valor Unitário NF:</strong> {{ Number(item.vlrunit).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p class="mb-0 pt-2"><strong>ICMS:</strong> {{ Number(item.vlrunit * (item.iCMSPercICMS / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p class="mb-0 pt-2"><strong>PIS:</strong> {{ Number(item.vlrunit * (item.pISPerc / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p class="mb-0 pt-2"><strong>COFINS:</strong> {{ Number(item.vlrunit * (item.cOFINSPerc / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p class="mb-0 pt-2"><strong>IBS:</strong> {{ Number(item.IBSValor || 0).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p class="mb-0 pt-2"><strong>CBS:</strong> {{ Number(item.CBSValor || 0).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p class="mb-0 pt-2"><strong>CSOSN:</strong> {{ item.CSOSNValor || 101  }}</p>
          <p class="mb-0 pt-2"><strong>Valor Real:</strong> {{ (item.vlrunit - (item.vlrunit * (item.cOFINSPerc / 100)) - (item.vlrunit * (item.pISPerc / 100)) - (item.vlrunit * (item.iCMSPercICMS / 100))).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
          <p v-if="item.seqItemPurchaseOrder" class="mb-0 pt-2"><strong>Seq. Pedido:</strong> {{ item.seqItemPurchaseOrder }}</p>
          <p v-if="item.codPurchaseOrder" class="mb-0 pt-2"><strong>Cod. Pedido:</strong> {{ item.codPurchaseOrder }}</p>
          <p v-if="item.status != 'Pendente'" class="mb-0 pt-2"><strong>N° NF Industrializacao:</strong> {{ item.nfIndustrializacao }}</p>
          <!-- {{ item.qty }} - {{  item.qtyReceived || 0 }} - {{ (item.qty - (item.qtyReceived || 0)) }} -->
          <v-text-field
            v-if="item.status === 'Pendente'"
            label="Quantidade"
            v-model="item.quantidade"
            dense
            outlined
            type="number"
            class="pt-2"
            :rules="[
              v => v !== null && v !== undefined && v !== '' || 'Campo obrigatório',
              v => parseFloat(v) >= 0 || 'Quantidade não pode ser negativa',
              //v => Number(v) <= maxPermitido || `Máximo permitido: ${maxPermitido}`
              v => parseFloat(v) <= Math.abs(item.qty - (item.qtyReceived || 0)) || `Máximo permitido: ${item.qty - (item.qtyReceived || 0)}`
            ]"
          />
          <!-- <v-text-field
            v-if="item.status === 'Pendente'"
            label="Seq. Pedido"
            v-model="item.seqItemPurchaseOrder"
            dense
            outlined
            class="pt-2"
          />
          <v-text-field
            v-if="item.status === 'Pendente'"
            label="N° do Pedido de Compra:"
            v-model="item.codPurchaseOrder"
            dense
            outlined
            class="pa-0 pt-2"
          /> -->
          <v-autocomplete
            v-if="item.status === 'Pendente'"
            v-model="item.local"
            :items="localOptions"
            label="Local Destino"
            item-text="text"
            item-value="id"
            dense
            outlined
            class="pa-0 pt-2"
            :disabled="item.osItem && item.osItem.item && codigosBloqueados.includes(item.osItem.item.code)"
            :rules="[
              v => {
                const code = item.osItem && item.osItem.item && item.osItem.item.code;
                if (code && codigosBloqueados.includes(code)) return true;
                return v !== null && v !== undefined && v !== '' || 'Campo obrigatório';
              }
            ]"
          ></v-autocomplete>
          <v-combobox
            v-if="item.status === 'Pendente'"
            data-action-nfremessa
            name="nfRemessa"
            label="N° NF Industrialização"
            :items="[]"
            v-model="item.nfIndustrializacao"
            chips
            multiple
            class="pa-0 pt-2"
          ></v-combobox>
          <v-btn 
            v-if="item.status === 'Pendente'"
            :disabled="!pedidoCompra.length > 0" 
            @click="handleOpenVincularPedidoModal(item)" 
            style="box-shadow: none; margin: 0px 0px; background-color: blue; color: white !important;" 
          >
            Vincular Item
          </v-btn>

          <div
            style="position: absolute; top: 0; right: 0; background-color: blue; color: white; padding: 2px 6px; border-radius: 0 0 0 4px; font-size: 12px;"
            v-if="item.osItem"
          >
            Item Vinculado
          </div>
        </v-card>
      </v-form>

    </v-container>
    <v-dialog v-model="isLocalDestinoDialogOpen" max-width="500px">v-container
      <v-card>
        <v-card-title>Alterar Local de Destino</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="localDestinoMassa"
            :items="localOptions"
            label="Selecione o local"
            item-text="text"
            item-value="id"
            dense
            outlined
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="isLocalDestinoDialogOpen = false">Cancelar</v-btn>
          <v-btn color="primary" @click="aplicarLocalDestinoEmMassa">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <RecebimentoDeNotaFiscalImportXmlView :open="isImportXmlOpen" @confirm="importData" @close="isImportXmlOpen = false" />
    <RecebimentoDeNotaFiscalBarcodeModal :openCamera="isBarcodeModalOpen" @barcode="handleBarcode" />
    <RecebimentoDeNotaFiscalRejeitarItemModal @close="handleCloseDeleteItemModal" @cancel="handleCancelDeleteItemModal" :nfItens="deletedItem" :value="isDeleteItemModalOpen" />
    <RecebimentoDeNotaFiscalVincularPedidoModal @close="handleCloseVinculaPedidoModal" @link="handleLinkPedido" :linkedItem="itemVinculadoData" :pedidoCompra="pedidoCompra" :value="isVincularPedidoModalOpen" />
    <AlertExedsQuantity :isOpen="isOpenAlertExedsQuantity" :itemsExedsQuantity="itemsExedsQuantity" @close="isOpenAlertExedsQuantity = false" />
  </v-container>
</template>
  
<script>
  import Vue from 'vue';
  import RecebimentoDeNotaFiscalBarcodeModal from './RecebimentoDeNotaFiscalBarcodeModalView.vue';
  import RecebimentoDeNotaFiscalRejeitarItemModal from './RecebimentoDeNotaFiscalRejeitarItemView.vue';
  import RecebimentoDeNotaFiscalVincularPedidoModal from './RecebimentoDeNotaFiscalVincularPedidoView.vue';
  import AlertExedsQuantity from './AlertExedsQuantity.vue';
  import { runAction } from '../../services/actionService';
  import moment from 'moment';
import RecebimentoDeNotaFiscalImportXmlView from './RecebimentoDeNotaFiscalImportXmlView.vue';
// import { set } from 'core-js/core/dict';

  export default {
    components: {
      RecebimentoDeNotaFiscalBarcodeModal,
      RecebimentoDeNotaFiscalRejeitarItemModal,
      RecebimentoDeNotaFiscalVincularPedidoModal,
      RecebimentoDeNotaFiscalImportXmlView,
      AlertExedsQuantity
    },  
    data() {
      return {
        isOpenAlertExedsQuantity: false,
        isImportXmlOpen: false,
        isBarcodeModalOpen: false,
        isDeleteItemModalOpen: false,
        isSaving: false,
        isLocalDestinoDialogOpen: false,
        isVincularPedidoModalOpen: false,
        itemVinculado: '',
        pedidoCompra: '',
        pedidoCompraList: [],
        pedidoCompraOptions: [],
        itemVinculadoData: {},
        localDestinoMassa: null,
        deletedItem: [],
        selectedItem: [],
        itemsExedsQuantity: [],
        user: {},
        isFormValid: false,
        notaFiscal: {},
        actionsMassa: [
          { 
            title: 'Recusar em Massa',
            handle: () => {
              this.handleOpenDeleteItemModal(this.selectedItem)
            }
          },
          { 
            title: 'Alterar Local de Destino em Massa',
            handle: () => {
              this.isLocalDestinoDialogOpen = true;
            }
          },
        ],
        hoveredItem: '',
        notaFiscalConta: {},
        notaFiscalItems: [],
        localDestino: '',
        localOptions: [],
        itemToDelete: null, 
        activeTab: 0,
        isModalOpen: false,
        searchText: '',
        item: [],
        rules: {
          required: v => !!v || "Campo obrigatório",
          min: v => v >= 0 || "Valor não pode ser negativo",
          max: v => v <= this.qty || `Máximo permitido é ${this.qty > 0 ? this.qty : 0}`
        },
        codigosBloqueados:  [
          "9000000", "9100000", "9200000",
          "9300000", "9400000", "9500000",
          "9600000", "9700000", "9800000",
        ]
      };
    },
    computed: {
      themeClass() {
        return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
      },
      maxPermitido() {
        // Evita que o máximo fique negativo
        const max = (this.item.qty || 0) - (this.item.qtyReceived || 0);
        return Math.max(0, max);
      }
    },
    methods: { 

      async getTenanty(){
        const lc = window.localStorage.getItem("UsuarioStore");
        const user = JSON.parse(lc);

        const req = await Vue.prototype.$http.get(`/Entity/Collaborator/search-fields?value=${user.id}&companySiteId=userId`)
        this.user = req?.data?.data?.data[0]
      },

      handleBarcode(data) {
        this.searchText = data;
        this.isBarcodeModalOpen = false;
        this.getNF();
      },

      async setIsBarcodeModalOpen() {
        this.isBarcodeModalOpen = !this.isBarcodeModalOpen;
      },

      setIsImportXmlOpen() {
        this.isImportXmlOpen = true;
      },

      async importData(items, codNf, chaveAcesso, numPedido, serie, nfDataSaiEnt) {
        try {
          console.log('items AQUI >>> ', this.pedidoCompraOptions, nfDataSaiEnt, numPedido);

          this.pedidoCompra = numPedido;
          this.searchText = chaveAcesso;

          this.notaFiscalItems = items;
          this.notaFiscal.numero = codNf || '';
          this.notaFiscal.serie = serie;
          this.notaFiscal.dataSaida = nfDataSaiEnt;

          const requestData = {
            params: [
              {
                name: 'pedido',
                dataType: 'String',
                value: numPedido,
              },
            ],
            viewName: 'get-pedido-compra-nf-recebimento',
            page: 1,
            limit: 1,
          };

          const response = await Vue.prototype.$http.post('/View/run', requestData);
          const itemsData = response.data.data.data[0]?.itens || [];

          this.itemsExedsQuantity = [];
          const filteredItems = [];

          console.log('notaFiscalItems >>> ', this.notaFiscalItems);
          console.log('itemsData pedido >>> ', itemsData);

          // Para cada item da nota fiscal
          this.notaFiscalItems.forEach(async (nfItem, index) => {
            // Tenta encontrar o item correspondente no pedido
            let osItem = itemsData.find(
              (i) =>
                i.pedidoDeCompraItemCodigo === nfItem.codPurchaseOrder ||
                i.sequencia === nfItem.seqItemPurchaseOrder
            );
            
            console.log('osItem teste ', nfItem.seqItemPurchaseOrder, nfItem.codPurchaseOrder, osItem);

            if (osItem) {
              // Define quantidade recebida com base na OS
              //nfItem.qtyReceived = osItem.quantidadeCompra || 0;

              // Valida excesso de quantidade
              if (nfItem.qty > osItem.quantidadeCompra) {
                this.itemsExedsQuantity.push(nfItem);
              }

              // Filtra apenas os itens válidos (independente da unidade)
              if (nfItem.qty <= osItem.quantidadeCompra) {
                filteredItems.push(nfItem);
              }

              // Atualiza campos com reatividade
              this.$set(nfItem, 'descriptionItem', nfItem.descriptionItem);
              //this.$set(nfItem, 'qtyReceived', osItem.quantidadeEntregue)
              this.$set(nfItem, 'quantidade', nfItem.qty);
              this.$set(nfItem, 'qty', nfItem.qty);
              this.$set(nfItem, 'osItem', osItem);
              this.$set(nfItem, 'codPurchaseOrder', osItem.codPurchaseOrder);
              this.$set(nfItem, 'seqItemPurchaseOrder', nfItem.seqItemPurchaseOrder);
            } else {
              // Garante que pelo menos os itens importados apareçam na tela
              this.$set(nfItem, 'quantidade', nfItem.quantidade ?? nfItem.qty);
            }
          });

          // Se conseguiu vincular algum item ao pedido, usa apenas os filtrados;
          // caso contrário, mantém todos os itens importados.
          if (filteredItems.length > 0) {
            // Remove duplicados pelo _id
            this.notaFiscalItems = Array.from(
              new Map(filteredItems.map((item) => [item._id, item])).values()
            );
          } else {
            this.notaFiscalItems = this.notaFiscalItems.map((item) => ({
              ...item,
              quantidade: item.quantidade ?? item.qty,
            }));
          }

          console.log('notaFiscalItems FINAL >>> ', this.notaFiscalItems);

          this.isImportXmlOpen = false;
          this.$notfy.success('Dados vinculados com sucesso!');

          if (this.itemsExedsQuantity.length > 0) {
            this.isOpenAlertExedsQuantity = true;
          }
        } catch (error) {
          console.error('Erro ao importar dados:', error);
          this.$notfy.error('Erro ao importar dados da nota fiscal.');
        }
      },


      async handleOpenDeleteItemModal(itemId) {
        const isArray = Array.isArray(itemId)
        if (isArray) {
          this.deletedItem = itemId
        } else {
          this.deletedItem = [itemId]
        }
        this.isDeleteItemModalOpen = true
      },

      handleOpenVincularPedidoModal(item) {
        this.itemVinculado = item._id;
        this.itemVinculadoData = item.osItem || null
        this.isVincularPedidoModalOpen = true;
      },

      handleLinkPedido(osItem, pedido) {
        const index = this.notaFiscalItems.findIndex(i => i._id === this.itemVinculado);
        if (index !== -1) {
          this.$set(this.notaFiscalItems[index], 'osItem', osItem);
          this.$set(this.notaFiscalItems[index], 'codPurchaseOrder', pedido);
          this.$set(this.notaFiscalItems[index], 'seqItemPurchaseOrder', osItem.sequencia);
          console.log(this.notaFiscalItems[index])
        }
        this.isVincularPedidoModalOpen = false;
        this.itemVinculado = ''; // opcional: limpa o estado
        this.itemVinculadoData = {};
      },

      handleCloseVinculaPedidoModal() {
        this.itemVinculado = '';
        this.itemVinculadoData = {};
        this.isVincularPedidoModalOpen = false
      },

      isItemSelected(item) {
        return this.selectedItem.some(i => i._id === item._id);
      },

      onItemCheck(item) {
        const exists = this.selectedItem.find(i => i._id === item._id);
        if (!exists) {
          this.selectedItem.push(item);
        } else {
          this.selectedItem = this.selectedItem.filter(i => i._id !== item._id);
        }
      },

      aplicarLocalDestinoEmMassa() {
        if (!this.localDestinoMassa) return;
        
        this.selectedItem.forEach(item => {
          item.local = this.localDestinoMassa;
        });

        this.isLocalDestinoDialogOpen = false;
        this.localDestinoMassa = null;
      },

      async handleCloseDeleteItemModal() {
        this.deletedItem = []
        this.isDeleteItemModalOpen = false
        this.getNF();
      },

      async handleCancelDeleteItemModal() {
        this.deletedItem = []
        this.isDeleteItemModalOpen = false
      // this.getNF();
      },

      async getLocalOptions() {
        let reqLocal = await Vue.prototype.$http.get(`/Entity/StockLocal?limit=99999`);
        let local = reqLocal.data.data.data

        this.localOptions = [
        ...new Map(
            local.map(locale => [locale.id, { text: locale.descricao, id: locale.id }])
        ).values()
        ].sort((a, b) => a.text.localeCompare(b.text));
      },

      async getNF() {
        let { data } = await Vue.prototype.$http.post('/View/run', {
          "params": [
            { dataType: "String", name: "chaveAcesso", value: this.searchText }
          ],
          "viewId": "c97748b9-eee5-4da3-bd4a-881ea34385bd",
          "page": 1,
          "limit": 1
        });
        const response = data.data.data[0]
        this.notaFiscal = response;
        this.notaFiscalItems = response.items.map(item => ({
          ...item,
          quantidade: item.qty
        }));
        this.notaFiscalConta = response.conta;
      },

      async capitalizeSelectedKeys(obj) {
        const keysToCapitalize = [
          'nCM',
          'cFOP',
          'cOFINSValor',
          'cOFINSPerc',
          'cOFINSBaseCalculo',
          'pISValor',
          'pISPerc',
          'pISBaseCalculo',
          'iPIValor',
          'iPIPercIPI',
          'iPIBaseCalculo',
          'iCMSValor',
          'iCMSPercICMS',
          'iCMSBaseCalculo'
        ];

        const result = {};

        for (const key in obj) {
          if (
            Object.prototype.hasOwnProperty.call(obj, key) &&
            obj[key] !== null &&
            obj[key] !== undefined &&
            obj[key] !== 'Empty'
          ) {
            if (keysToCapitalize.includes(key)) {
              const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
              result[capitalizedKey] = obj[key];
            } else {
              result[key] = obj[key];
            }
          }
        }

        return result;
      },

      calcValorMedio(data) {
        const COFINS = Number(data.COFINSValor || 0);
        const PIS = Number(data.PISValor || 0);
        const IBS = Number(data.IBSValor || 0);
        const CBS = Number(data.CBSValor || 0);
        const ICMS = Number(data.ICMSValor || 0);
        const CSOSN = data.CSOSN || '101';
        const quantidadeEntrada = Number(data.quantidadeEntrada || 0);
        const quantidadeEstoque = Number(data.quantidadeTotal || 0);
        const valorUnitarioEntrada = Number(data.valorMedio || 0);

        const geraCreditoICMS = CSOSN === '101';

        const custoUnitarioEntrada =
          valorUnitarioEntrada +
          IBS +
          CBS +
          PIS +
          COFINS -
          (geraCreditoICMS ? ICMS : 0);

        const custoTotalEntrada = custoUnitarioEntrada * quantidadeEntrada;

        const custoTotalEstoque = valorUnitarioEntrada * quantidadeEstoque;

        const novoValorMedio =
          (custoTotalEstoque + custoTotalEntrada) /
          (quantidadeEstoque + quantidadeEntrada || 1);

        return Number(novoValorMedio.toFixed(4));

      },

      async Update() {
        this.isSaving = true;
        if (this.$refs.form.validate()) {
          // INSERIR ITENS DE NOTA FISCAL EM SALDO DE ESTOQUE (FisDocRecItem -> StockBalance)
          console.log('UPDATE >>> ', this.notaFiscalItems)
          let i = 0
          for(const item of this.notaFiscalItems) {
            i += 1
            const reqDestino = await Vue.prototype.$http.get(
              `/Entity/StockBalance/search-fields?value=[${item.osItem.item._id}],[${item.local}]&searchFields=[item],[localEstoque]`
            );

            console.log(item)

            const localEstoqueDestinoDescricao = this.localOptions.find(local => local.id === item.local)?.text;

            const destinoData = reqDestino.data.data.data[0];
            const destinoExists = reqDestino.data.data.total > 0;
            
            const cleanDestino = destinoExists
              ? (({ updateAt, updateBy, deleteAt, deleteBy, isDeleted, ...rest }) => rest)(destinoData)
              : null;

            if (destinoExists) {
              const valorMedio = Number((Number(item.vlrunit * (item.quantidade + cleanDestino.quantidadeTotal))) / Number(Number(cleanDestino.quantidadeTotal) + Number(item.quantidade))) ?? 0;
/*
              const valorMedio = this.calcValorMedio({
                CSOSN: item.CSOSNValor || '101',
                quantidadeEntrada: Number(item.quantidade),
                quantidadeTotal: Number(cleanDestino.quantidadeTotal || 0),
                ICMSValor: item.vlrunit * (item.iCMSPercICMS / 100),
                PISValor: item.vlrunit * (item.pISPerc / 100),
                COFINSValor: item.vlrunit * (item.cOFINSPerc / 100),
                IBSValor: Number(item.IBSValor || 0),
                CBSValor: Number(item.CBSValor || 0),
                valorMedio: Number(item.vlrunit)
              });*/

              if(!this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo))){
                await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                  ...cleanDestino,
                  // quantidadeTotal: Number(Number(cleanDestino?.quantidadeTotal) + Number(item.quantidade)),
                  // quantidadeDisponivel: Number(Number(cleanDestino?.quantidadeDisponivel) + Number(item.quantidade)),quantidadeTotal: Number(item.quantidade),
                  quantidadeDisponivel: Math.abs(Number(item.quantidade) - Number(item.osItem.quantidade)),  //Number(item.quantidade),
                  quantidadeReservado: Number(item.osItem.quantidade),
                  valorTotal: Number(item.vlrunit * (item.quantidade + cleanDestino.quantidadeTotal)),
                  valorMedio: !this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo)) ? Number((item.vlrunit * item.quantidade) / Number(item.quantidade)) ?? 0 : 0, //valorMedio || undefined,
                  valorReal: !this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo)) ? (valorMedio - (item.vlrunit * (item.cOFINSPerc / 100)) - (item.vlrunit * (item.pISPerc / 100)) - (item.vlrunit * (item.iCMSPercICMS / 100))) || undefined : 0,
                  ICMSValor: (item.vlrunit * (item.iCMSPercICMS / 100)) || undefined,
                  PISValor: (item.vlrunit * (item.pISPerc / 100)) || undefined,
                  COFINSValor: (item.vlrunit * (item.cOFINSPerc / 100)) || undefined,
                  IBSValor: Number(item.IBSValor || 0) || undefined,
                  CBSValor: Number(item.CBSValor || 0) || undefined,
                  CSOSNValor: item.CSOSNValor || '101',
                  dataAlteracao: new Date().toLocaleDateString(),
                  //unidadeSigla: undefined
                });

                // INSERIR HISTÓRICO NO SALDO DE ESTOQUE (HistoricoMovimentacaoItem -> StockBalance)

                const newCodigoHistoricoOrigem = await Vue.prototype.$http.get(
                  "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                );

                await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                  "codigo": newCodigoHistoricoOrigem.data,
                  "tipo": 'Entrada',
                  "descricao": `RECEBIMENTO DE NOTA FISCAL N°${this.notaFiscal.numero} PARA ${localEstoqueDestinoDescricao}`,
                  "dataMovimentacao": moment().format("YYYY-MM-DD"),
                  "quantidade": Number(item.quantidade),
                  "colaboradorDaMovimentacao": this.user.id,
                  "saldoDeEstoque": cleanDestino.id,
                  "item": item.osItem.item._id,
                  "notaFiscalRecebida": this.notaFiscal._id,
                  "os": item.osItem.ordemDeServico._id,
                  "osItem": item.osItem._id,
                  "job": item.osItem.ordemDeServico.job._id,
                  "ICMSValor": (item.vlrunit * (item.iCMSPercICMS / 100)) || undefined,
                  "PISValor": (item.vlrunit * (item.pISPerc / 100)) || undefined,
                  "COFINSValor": (item.vlrunit * (item.cOFINSPerc / 100)) || undefined,
                  "IBSValor": Number(item.IBSValor || 0) || undefined,
                  "CBSValor": Number(item.CBSValor || 0) || undefined,
                  "CSOSNValor": item.CSOSNValor || '101',
                });

                this.$notfy.success('Operação realizada com sucesso !');
              }


            } else {
              const newCodigo = await Vue.prototype.$http.get(
                "/Entity/AutoInc?schemaName=StockBalance&field=codigo&mask=######"
              );

              if(!this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo))){
                const newOrigem = await Vue.prototype.$http.post(`/Entity/StockBalance`, {
                  codigo: newCodigo.data,
                  item: item.osItem.item._id,
                  localEstoque: item.local,
                  valorMedio:  !this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo)) ? Number((item.vlrunit * item.quantidade) / Number(item.quantidade)) ?? 0 : 0,
                  valorTotal: Number(item.vlrunit * item.quantidade),
                  valorReal: !this.codigosBloqueados?.some(codigo => item.osItem.item.code?.includes(codigo)) ? item.vlrunit - (item.vlrunit * (item.cOFINSPerc / 100)) - (item.vlrunit * (item.pISPerc / 100)) - (item.vlrunit * (item.iCMSPercICMS / 100)) : 0,
                  quantidadeTotal: Number(item.quantidade),
                  quantidadeDisponivel: Math.abs(Number(item.quantidade) - Number(item.osItem.quantidade)),  //Number(item.quantidade),
                  quantidadeReservado: Number(item.osItem.quantidade),
                  ICMSValor: Number(item.vlrunit * (item.iCMSPercICMS / 100)),
                  PISValor: Number(item.vlrunit * (item.pISPerc / 100)),
                  COFINSValor: Number(item.vlrunit * (item.cOFINSPerc / 100)),
                  IBSValor: Number(item.IBSValor || 0),
                  CBSValor: Number(item.CBSValor || 0),
                  CSOSNValor: item.CSOSNValor || '101',
                  dataAlteracao: new Date().toLocaleDateString()
                });

                // INSERIR HISTÓRICO NO SALDO DE ESTOQUE (HistoricoMovimentacaoItem -> StockBalance)
                const newCodigoHistoricoOrigem = await Vue.prototype.$http.get(
                  "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                );

                await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                  "codigo": newCodigoHistoricoOrigem.data,
                  "tipo": 'Entrada',
                  "descricao": `RECEBIMENTO DE NOTA FISCAL N°${this.notaFiscal.numero} PARA ${localEstoqueDestinoDescricao}`,
                  "dataMovimentacao": moment().format("YYYY-MM-DD"),
                  "quantidade": Number(item.quantidade),
                  "colaboradorDaMovimentacao": this.user.id,
                  "saldoDeEstoque": newOrigem.data.data.id,
                  "item": item.osItem.item._id,
                  "notaFiscalRecebida": this.notaFiscal._id,
                  "os": item.osItem.ordemDeServico._id,
                  "osItem": item.osItem._id,
                  "job": item.osItem.ordemDeServico.job._id,
                  "ICMSValor": (item.vlrunit * (item.iCMSPercICMS / 100)),
                  "PISValor": (item.vlrunit * (item.pISPerc / 100)),
                  "COFINSValor": (item.vlrunit * (item.cOFINSPerc / 100)),
                  "IBSValor": Number(item.IBSValor || 0),
                  "CBSValor": Number(item.CBSValor || 0),
                  "CSOSNValor": item.CSOSNValor || '101',
                });

              //this.$notfy.success('Operação realizada com sucesso !');
              }

            }

            const {
              _id,
              updateAt,
              updateBy,
              deleteAt,
              deleteBy,
              isDeleted,
              pedidoDeCompra,
              operacaoFiscal,
              quantidade,
              local,
              nfIndustrializacao,
              osItem,
              item: nestedItem,
              ...rest
            } = item;

            const {
              updateAt: updateAtOs,
              updateBy: updateByOs,
              deleteAt: deleteAtOs,
              deleteBy: deleteByOs,
              destino,
              isDeleted: isDeleteOs,
              ordemDeServico,
              _id: idOs,
              ...osRest
            } = osItem;

            const status = item.status !== 'Pendente'
                ? item.status
                : Number(osRest.quantidadeCompra) <= Number(osRest.quantidadeEntregue ?? 0)
                ? 'RE' 
                : Number(osRest.quantidade ?? 0) > Number(osRest.quantidadeCompra ?? 0)
                ? 'RP'
                : 'GP'

            console.log(`ITEM ${i} >>> `, item.status, osRest.quantidadeCompra, osRest.quantidadeEntregue, osRest.quantidade)
            console.log('STATUS >>> ', status)

            const payloadOs = {
              ...osRest,
              id: idOs,
              item: osRest.item?._id,
              fornecedorMaterialFornecido: osRest.fornecedorMaterialFornecido?._id,
              unidade: osRest.unidade?._id,
              unidadeCompra: osRest.unidadeCompra?._id,
              quantidadeEntregue: Number(osRest.quantidadeEntregue ?? 0) + Number(quantidade),
              pedidoDeCompraItemID: undefined,
              pedidoDeCompraItemCodigo: undefined,
              status
            };

            // Filtra o payload para remover chaves com valor `null` ou `undefined`
            const filteredPayload = Object.fromEntries(
              Object.entries(payloadOs).filter(([_, v]) => v !== null && v !== undefined)
            );

            await Vue.prototype.$http.put(`/Entity/OrdemDeServicoItens`, filteredPayload);
            
            const formatted = await this.capitalizeSelectedKeys(rest);

            const reqItem = await Vue.prototype.$http.get(
              `/Entity/FisDocRecItem/search-fields?ids=${item._id},`
            );

            const reqItemData = reqItem?.data?.data?.data[0]

            if(reqItemData){
            const {
              updateAt: updateAtItem,
              updateBy: updateByItem,
              deleteAt: deleteAtItem,
              deleteBy: deleteByItem,
              isDeleted: isDeleteItem,
              ...restItem
            } = reqItemData;

            const noNullValuesRestItem = Object.fromEntries(
              Object.entries(restItem).filter(([_, v]) => v !== null && v !== undefined)
            );

            await Vue.prototype.$http.put(`/Entity/FisDocRecItem`, {
              ...noNullValuesRestItem,
              ...(nfIndustrializacao && nfIndustrializacao.length > 0
                ? { nfIndustrializacao: Array.isArray(nfIndustrializacao) ? nfIndustrializacao.join(',') : nfIndustrializacao }
                : {}),
              seqItemPurchaseOrder: Number(osRest.sequencia),
              codPurchaseOrder: this.pedidoCompra,
              qtyReceived: item.qtyReceived ? String(Number(item.qtyReceived) + Number(quantidade)) : String(quantidade),
              status: item.status != 'Pendente' 
                ? item.status 
                : Number(Number(quantidade) + Number(item.qtyReceived ?? 0)) === Number(item.qty) 
                ? 'Recebido'
                : Number(Number(quantidade) + Number(item.qtyReceived ?? 0)) <= Number(item.qty) && Number(Number(quantidade) + Number(item.qtyReceived ?? 0)) > 0
                ? 'Recebido Parcialmente'
                : 'Pendente' 
            });

          }

          // ATUALIZAR STATUS DE NOTA FISCAL (FisDocRec)
          const reqNF = await Vue.prototype.$http.get(
            `/Entity/FisDocRec/search-fields?value=${this.searchText}&searchFields=chaveAcesso&mode=Equals`
          );

          const NFData = reqNF.data.data.data[0];

          console.log('NFData >>> ', NFData)
          console.log('notaFiscalItems >>> ', this.notaFiscalItems)
          
            if(NFData){
            const cleanNF = (({ updateAt, updateBy, deleteAt, deleteBy, isDeleted, ...rest }) => rest)(NFData)

            await Vue.prototype.$http.put(`/Entity/FisDocRec`, {
              ...cleanNF,
              status: this.notaFiscalItems.every(item => item.qty > item.quantidade) ? 'Recebida Parcialmente' : 'Recebida'
            });
          } else {
            await this.createFinRec(Number(osRest.sequencia))
          }

        }

          await this.getNF();
          this.$notfy.success('Operação realizada com sucesso !');

          Vue.prototype.$notify({
            title: "Nota Recebida com Sucesso!",
            closeOnClick: true,
            duration: 3000,
            positions: "right",
            type: "success",
          });
        }
        this.isSaving = false;
      },

      async getPurchaseOrderOptions () {
        const req = await Vue.prototype.$http.get(`/Entity/PedidoDeCompra/search-fields?limit=99999&page=1`);
        const data = req.data.data.data;
        this.pedidoCompraList = data;
        const  options = data.map(order => ({
          text: order.codigo,
          value: order.codigo
        }))
        this.pedidoCompraOptions = options
      },

      async createFinRec(sequencia) {
        console.log("notaFiscalItems >>> ", this.notaFiscalItems);

        const finDocRecItem = this.notaFiscalItems.map((nfItem) => {
          const quantidade = Number(nfItem.quantidade ?? 0);
          const qtyReceived = Number(nfItem.qtyReceived ?? nfItem.quantidadeEntregue ?? 0);
          const qtyTotal = quantidade + qtyReceived;

          const status =
            nfItem.status !== "Pendente"
              ? nfItem.status
              : qtyTotal === Number(nfItem.qty)
              ? "Recebido"
              : qtyTotal > 0 && qtyTotal < Number(nfItem.qty)
              ? "Recebido Parcialmente"
              : "Pendente";

          return {
            seqitem: nfItem.seqitem,
            // itemId: "",
            codPurchaseOrder: this.pedidoCompra,
            seqItemPurchaseOrder: sequencia,
            descriptionItem: nfItem.descriptionItem,
            qty: quantidade.toString(),
            qtyReceived: qtyReceived > 0 ? qtyReceived.toString() : quantidade.toString(),

            vlrunit: Number(nfItem.vlrunit ?? 0).toFixed(2),
            vlrtotal: Number(nfItem.vlrtotal ?? 0).toFixed(2),

            ICMSBaseCalculo: Number(nfItem.iCMSVlrICMS ?? 0).toFixed(2),
            ICMSPercICMS: Number(nfItem.iCMSPercICMS ?? 0).toFixed(2),
            ICMSValor: Number(nfItem.iCMSVlrICMS ?? 0).toFixed(2),

            IPIBaseCalculo: Number(nfItem.valorIPI ?? 0).toFixed(2),
            IPIPercIPI: nfItem.porcentagemIPI?.toString(),
            IPIValor: Number(nfItem.valorIPI ?? 0).toFixed(2),

            PISBaseCalculo: Number(nfItem.pISVlrPIS ?? 0).toFixed(2),
            PISPerc: nfItem?.pISPerc?.toString(),
            PISValor: Number(nfItem.pISVlrPIS ?? 0).toFixed(2),

            COFINSBaseCalculo: Number(nfItem.cOFINSVlrCOFINS ?? 0).toFixed(2),
            COFINSPerc: nfItem?.cOFINSPerc?.toString(),
            COFINSValor: Number(nfItem.cOFINSVlrCOFINS ?? 0).toFixed(2),

            cfop: nfItem.cfop,
            ncm: nfItem.ncm,
            status,
          };
        });

        console.log("finDocRecItem >>> ", finDocRecItem);

        // Insert dos itens
        const response = await Vue.prototype.$http.post(
          "/Entity/insertMany/FisDocRecItem",
          finDocRecItem
        );

        const itensFinDocRec = response.data.data;

        // Insert do documento pai
        await Vue.prototype.$http.post("/Entity/FisDocRec", {
          porjectId: this.notaFiscalItems[0].osItem.ordemDeServico.job._id,
          osId: this.notaFiscalItems[0].osItem.ordemDeServico._id,
          pedidoDeCompra: this.pedidoCompraList.filter(item => item.codigo === this.pedidoCompra)[0].id,
          item: this.notaFiscalItems[0].osItem.item._id,
          companySiteId: "c511a33d-6b85-4cdf-88af-6a221f0eb46d",
          valorOriginal: this.notaFiscalItems[0].vlrTotal,
          valorParaReservar: this.notaFiscalItems[0].vlrTotal,
          serie: this.notaFiscal.serie,
          numero: this.notaFiscal.numero,
          chaveAcesso: this.searchText,
          dataEmissao: new Date(),
          dataES: new Date(this.notaFiscal.dataSaida),
          fisDocRecItemS: itensFinDocRec.map((item) => item.id),
        });
      }

    },
    created() {
      this.getTenanty();
      this.getLocalOptions();
      this.getPurchaseOrderOptions();
    }
  };
  </script>
  <style scoped>
  
    .v-data-table thead th,
    .v-data-table tbody td {
      text-overflow: ellipsis; /* Trunca textos longos */
      white-space: nowrap;
      overflow: hidden;
    }
  
    ::-webkit-scrollbar {
      height: 5px !important;
    }
  
    ::-webkit-scrollbar-thumb {
      background-color: #230BC1 !important;
    }
  
    .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
      height: 48px;
      border-bottom: 0;
    }
  
    .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
      text-align: center !important;
      border-bottom: 0 !important;
    }
  
    .statusTd {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      height: 53px !important;
    }
  
    .activeCircle {
      border: 1px solid rgb(197, 167, 34);
      border-radius: 100%; 
      height: 0.5rem; 
      width: 0.5rem; 
      opacity: 80%; 
      background-color: rgb(34 197 94);
    }
  
    .inactiveCircle {
      border: 1px solid rgb(197, 167, 34);
      border-radius: 100%; 
      height: 0.5rem; 
      width: 0.5rem; 
      opacity: 80%; 
      background-color: #F00;
    }
  
    .v-application .elevation-1 {
      box-shadow: none !important;
    }
  
    .mdi-arrow-up::before {
      font-size: 15px !important;
    }
  
    .mdi-arrow-up::after {
      font-size: 15px !important;
    }
  
    .actionIcon {
      font-size: 18px !important;
    }
  
    .v-text-field--outlined fieldset {
      border: 0;
      border-bottom: 1px solid black;
      border-radius: 0;;
    }
  
    .v-text-field--outlined .v-text-field__slot {
      align-items: end !important;
    }
  
    .v-text-field .v-input__slot {
      padding: 0 !important;
    }
  
    .filterInput {
      outline: none;
      border: 1px solid #e1e1e1;
      color: #000;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    .theme--dark > .filterInput {
      outline: none;
      border: 1px solid #e1e1e1;
      color: #FFF !important;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    .filterInputDate {
      outline: none;
      border: 1px solid #666;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    input[type="date"]::-webkit-calendar-picker-indicator {
      cursor: pointer;
      border-radius: 4px;
      margin-right: 2px;
      opacity: 0.6;
      filter: invert(0.8);
    }
  
    .container {
      margin-right: 0;
      margin-left: 0;
      max-width: 100%;
    }
    
    .theme--dark > .dialogTitle {
      color: #000;
    }
  
     .dark-theme {
      background-color: #1E1E1E;
    }
  
    .v-slide-group__prev, .v-slide-group__prev--disabled {
      display: none !important;
    }
  
    .v-slide-group__next--disabled, .v-slide-group__prev--disabled {
      display: none !important;
    }
  
    .dark-theme {
      color: white;
    }
  
    .light-theme {
      color: #666;
    }

    .addButton {
      display: flex;
      gap: "12px"
    }

    ::v-deep(.v-data-table td) {
      overflow: hidden !important;
    }

    ::v-deep(.v-text-field__details) {
      display: none !important;
    }
  </style>